module.exports = __webpack_public_path__ + "img/제주 스테이크.205c42da.png";